export class Enrolment {
    server_enrolment_id=0
    subscriptions:[]
    server_student_id:0
    server_level_id:0
}
